import axios from 'axios';

const API_BASE = 'https://unscramble-production.up.railway.app/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 120000, //2 minutes for transcription
});

export const transcribeAudio = async (audioBlob) => {
  const formData = new FormData();

  //Determine file extension based on mime type
  const mimeType = audioBlob.type || 'audio/webm';
  const extension = mimeType.includes('mp3') ? 'mp3' :
                   mimeType.includes('wav') ? 'wav' :
                   mimeType.includes('m4a') ? 'm4a' : 'webm';

  formData.append('audio', audioBlob, `recording.${extension}`);

  try {
    const response = await api.post('/transcribe', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error('Failed to transcribe audio. Please try again.');
  }
};

export const structureTranscript = async (transcript) => {
  try {
    const response = await api.post('/structure', { transcript });
    return response.data;
  } catch (error) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error('Failed to structure transcript. Please try again.');
  }
};

export const checkHealth = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    throw new Error('Backend service is unavailable.');
  }
};

export default api;
